import { gql } from '@apollo/client';

export type {
  CreateOrUpdateWebhookUrl as ICreateOrUpdateWebhookUrl,
  CreateOrUpdateWebhookUrlVariables as ICreateOrUpdateWebhookUrlVariables,
} from './__generated__/CreateOrUpdateWebhookUrl';

export const CREATE_WEBHOOK_URL = gql`
  mutation CreateOrUpdateWebhookUrl($webhookUrl: String!) {
    createOrUpdateWebhookUrl(webhookUrl: $webhookUrl) {
      success
      webhookUrl
    }
  }
`;
